import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_LOGO = "empty_file";
export const ERROR_UNACCEPTED_FORMAT = "unaccepted_format";
export const ERROR_SIZE_EXCEEDED = "file_size_eceeded";
export const ERROR_SOMETHING_WENT_WRONG = "something_went_wrong";

export default formWithMessages(props => {
  const { onSave, disabled } = props;
  return (
    <Form
      formProps={{
        id: `logo-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        logoUpload: {
          uiProps: {
            type: "file",
          },
          position: 1,
          initialValue: "",
          label: "Partner logo ",
        },
      }}
      validation={formData => {
        if (!formData.logoUpload) return ERROR_EMPTY_LOGO;
        if (
          formData.fileObj &&
          formData.fileObj.type !== "image/png" &&
          formData.fileObj.type !== "image/jpeg"
        )
          return ERROR_UNACCEPTED_FORMAT;
        if (formData.fileObj && formData.fileObj.size / 1024 > 200)
          return ERROR_SIZE_EXCEEDED;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_LOGO]: "Please upload an image",
        [ERROR_UNACCEPTED_FORMAT]:
          "The image must be of type image/png or image/jpeg",
        [ERROR_SIZE_EXCEEDED]:
          "The image is too big maximum size allowed is 200 kb ",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/Logo.js